require('./brokerRightsSellStep2.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const trim = require('lodash/string/trim');
const moment = require('moment');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { CHARGE_ACCOUNT_PREFIX, FIRST_STEP, SECOND_STEP, BROKER_PRODUCT_TYPE_CAPITAL_INCREASE } = require('constants/index');
const { BROKER_RIGHTS_SELL_ID } = require('constants/operationTypes');

// @commons
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKMessage } = require('commonsComponents/OKMessage');
const OKTooltip = require('commonsComponents/OKTooltip');
const { OKLink } = require('commonsComponents/OKLink');

// @components
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const WebappRender = require('components/conditionalRender/webappRender');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
import BrokerLegalDocumentation from 'components/broker/brokerLegalDocumentation/brokerLegalDocumentation';
const SubscriptionLegalConfirmation = require('components/contactCenter/brokerLegalConfirmation/subscriptionLegalConfirmation/subscriptionLegalConfirmation');
const BrokerExAntSection = require("components/commons/brokerExAntSection/brokerExAntSection");
const { LoadingSection } = require('commonsComponents/loadingSection');

// @utilities
const PersonalDataHelper = require('utilities/personalDataHelper');

// @constants
const {
    BROKER_CORPORATE_OPERATIONS_SUBSCRIPTION_PRODUCT_TYPE,
    BROKER_ORDER_TYPE_SUBSCRIPTION,
    DATE_FORMAT_API,
} = require('constants/index');
const SELECTED_VALUES = require('constants/contactCenter/brokerLegalConfirmationSelectedValues');
const { RIGHTS_SELL_SHOW_COST } = require('constants/flagBasedFeatures');

class BrokerRightsSellStep2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedLegalConfirmationValue: SELECTED_VALUES.EMPTY,
        };
        this.handleLegalYesNoOptionChange = this.handleLegalYesNoOptionChange.bind(this);
    }

    componentWillMount() {
        const { getExAnteData, history, immFlagBasedFeatures } = this.props;
        if (immFlagBasedFeatures.get(RIGHTS_SELL_SHOW_COST)) {
            getExAnteData(history);
        }
    }

    handleLegalYesNoOptionChange(value) {
        this.setState({
            selectedLegalConfirmationValue: value
        });
    }

    buildExAnteData() {
        const { immBrokerRightsSell } = this.props;
        if (immBrokerRightsSell.get('exAnteDataFetching')) {
            return <LoadingSection/>;
        }
        return (
            !!immBrokerRightsSell.get("exAnteData") &&
                immBrokerRightsSell
                    .get("exAnteData")
                    .map((item, index) => (
                        <BrokerExAntSection
                            context="brokerRightsSell"
                            eventCategory="orden venta derechos/paso 2"
                            section={item}
                            key={index}
                            complexTooltip={true}
                        />
                    ))
        );
    }

    getPrecontractualMailParams() {
        const { immProfileFields, immBrokerSubscription } = this.props;

        const controlDigit = trim(immBrokerSubscription.get('digitodecontrol'));
        const productNumber = trim(immBrokerSubscription.getIn(['contract', 'product']));
        const contractNumber = trim(immBrokerSubscription.getIn(['contract', 'number']));
        const idContract = `${CHARGE_ACCOUNT_PREFIX}${controlDigit}${productNumber}${contractNumber}`;

        const owner = trim(immBrokerSubscription.get('owner'));
        const momentEndDate = moment(immBrokerSubscription.getIn(['value', 'endDate']));

        return {
            productKID: '',
            contract: '',
            marketingReport: '',
            infoCcv: '',
            idOrder: '',
            market: '',
            termValidity: momentEndDate.format(DATE_FORMAT_API),
            holders: owner,
            leafletSusbcription: trim(immBrokerSubscription.get('linkTriptico')),
            cnmvDocumentation: trim(immBrokerSubscription.get('linkCNMV')),
            ccv: idContract,
            ccc: '',
            idContract: idContract,
            email: trim(PersonalDataHelper.getEmail(immProfileFields)),
            clientAlias: trim(immProfileFields.get('nombreCliente')),
            isin: trim(immBrokerSubscription.getIn(['value', 'isin'])),
            isinDescribe: trim(immBrokerSubscription.getIn(['value', 'descriptionValue'])),
            orderType: BROKER_ORDER_TYPE_SUBSCRIPTION,
            productType: BROKER_CORPORATE_OPERATIONS_SUBSCRIPTION_PRODUCT_TYPE,
            sharesNumber: '',
            sharesAmount: '',
            orderCondition: '',
            conditionPrize : '',
            currency: ' ',
            mifidWarningText: '',
            dateTime: '',
        };
    }

    builSubscriptionLegalConfirmation(bookletLabel, CNMVLabel) {
        const {
            immBrokerSubscription,
            immCorporatesOperations,
            immProfileFields,
            immPreContractualMail,
            sendPreContractualMail,
            resetPrecontractualMail,
            requestProfile,
            immFlagBasedFeatures,
        } = this.props;
        const immCorporatesOperation = immBrokerSubscription.get('value');
        const currency = immCorporatesOperations.getIn(['selectedContract', 'associatedAccount', 'balance', 'currency']);
        const bookletLink = (
            <OKLink modifier="emphasize" to={immBrokerSubscription.get('linkTriptico')} target="_blank">
                {bookletLabel}
            </OKLink>
        );
        const CNMVLink = (
            <OKLink modifier="emphasize" to={immBrokerSubscription.get('linkCNMV')} target="_blank">
                {CNMVLabel}
            </OKLink>
        );
        const exAnteSection = immFlagBasedFeatures.get(RIGHTS_SELL_SHOW_COST) ? (
            <div className="broker-rights-sell-step2__ex-ante-container-cc">
                {this.buildExAnteData()}
            </div>
        ) : null;

        return (
            <SubscriptionLegalConfirmation
                immCorporatesOperation={immCorporatesOperation}
                currency={currency}
                legalinformationLinks={[bookletLink, CNMVLink]}
                immPreContractualMail={immPreContractualMail}
                sendMail={sendPreContractualMail}
                sendMailParams={this.getPrecontractualMailParams()}
                resetMailState={resetPrecontractualMail}
                immProfileFields={immProfileFields}
                requestProfile={requestProfile}
                selectedYesNoOption={this.state.selectedLegalConfirmationValue}
                onYesNoOptionChange={this.handleLegalYesNoOptionChange}
                exAnteCost={exAnteSection}
            />
        );
    }

    render() {
        const {
            immBrokerRightsSell,
            immProfileFields,
            immCorporatesOperations,
            handleDisclaimerCheckboxChange,
            setDocumentsRead,
            immFlagBasedFeatures,
        } = this.props;
        const selectedContract = immCorporatesOperations.get('selectedContract');
        const operationParams = {
            chargeAccount:
                CHARGE_ACCOUNT_PREFIX +
                selectedContract.getIn(['contract', 'product']) +
                selectedContract.getIn(['contract', 'number']),
            bondsNumber: immBrokerRightsSell.getIn(['steps', FIRST_STEP, 'rightsQuantity'])
        };
        const immStep = immBrokerRightsSell.getIn(['steps', SECOND_STEP]);
        const selectedCorporateOperationIndex = immBrokerRightsSell.get('selectedCorporateOperationIndex');
        const operation = immCorporatesOperations.getIn(['selectedContract', 'operations', selectedCorporateOperationIndex], false);
        const disclaimerChecked = immStep.get('isDisclaimerChecked');
        const disclaimerErrorVisible = immStep.get('disclaimerIsDirty') && !disclaimerChecked;
        const disclaimerErrorMsg = formatText('broker-broker_rightsSellStep2DisclaimerTextCheckboxErrorMsg');
        const clientName = PersonalDataHelper.getFullName(immProfileFields, false);
        const isin = operation.get('isin')
        const iso = operation.get('iso')
        const showWarning = immStep.get('showWarning')
        const productDefinition = operation.get('descriptionValue')


        const bookletLabel = <FormattedText value="brokerSubscription-informativeMessageBookletLabel"/>
        const CNMVLabel = <FormattedText value="brokerSubscription-informativeMessageCNMVLabel"/>

        const disclaimerLabel = (
            <FormattedTextWithComponents
                value="broker-broker_rightsSellStep2DisclaimerText"
                injectedComponents={[bookletLabel,CNMVLabel]}
            />
        );

        let documentsNotRead = null;
        if (showWarning) {
            documentsNotRead = (
                <div className="broker-rights-sell-step2__warning-message">
                    <OKMessage type="warning">
                        <FormattedText value="brokerLegalDocumentation-documentsRead" />
                    </OKMessage>
                </div>
            )
        }

        let signaturePattern = null;
        if (disclaimerChecked || (this.state.selectedLegalConfirmationValue === SELECTED_VALUES.YES)) {
            signaturePattern = (
                <div className="broker-rights-sell-step2__group-div">
                    <ContactCenterRender>
                        <BlockInfo extraClass="broker-legal-confirmation__block-info">
                            <FormattedText
                                injectedStrings={[clientName]}
                                value="cc_broker-rightsSellStep2Disclaimer"
                                className="broker-rights-buy-step2__info-message-body"
                            />
                        </BlockInfo>
                    </ContactCenterRender>
                    <SignaturePattern
                        operationType={BROKER_RIGHTS_SELL_ID}
                        operationParams={operationParams}
                        printTitleValue={'brokerLegalConfirmation-title'}
                    />
                </div>
            )
        }
        const legalConfirmation = this.builSubscriptionLegalConfirmation(bookletLabel, CNMVLabel);
        const exAnteSection =
            immFlagBasedFeatures.get(RIGHTS_SELL_SHOW_COST) &&
            !__CONTACT_CENTER__ ? (
                <div className="broker-rights-sell-step2__ex-ante-container">
                    {this.buildExAnteData()}
                </div>
            ) : null;

        return (
            <article className="broker-rights-sell-step2">
                <header className="broker-rights-sell-step2__header">
                    <h2 className="broker-rights-sell-step2__header-title">
                        <FormattedText value="broker-rightsSellStep2HeaderTitle" />
                    </h2>
                    <h4 className="broker-rights-sell-step2__header-subtitle">
                        <FormattedText value="broker-rightsSellStep2HeaderSubtitle" />
                    </h4>
                </header>
                <WebappRender>
                    <div className="broker-rights-sell-step2__checkbox-container">
                        <BrokerLegalDocumentation
                            isin={isin}
                            iso={iso}
                            productDefinition={productDefinition}
                            productType={BROKER_PRODUCT_TYPE_CAPITAL_INCREASE}
                            reportCompleted={() => setDocumentsRead()}
                        />
                        {documentsNotRead}
                        {!__CONTACT_CENTER__ && exAnteSection}
                        <OKTooltip
                            content={<FormattedText value={'planLegalDocumentDisclaimer-warningTooltip'}/>}
                            offset={[-50, -5]}
                            placement={'topLeft'}
                            target={
                                <div className="broker-rights-sell-step2__checkbox-container">
                                    <OKCheckbox
                                        idName="brokerRightsSellCheckbox"
                                        errorState={disclaimerErrorVisible}
                                        errorMessage={disclaimerErrorMsg}
                                        label={disclaimerLabel}
                                        onChange={handleDisclaimerCheckboxChange}
                                        value={disclaimerChecked}
                                    />
                                </div>
                            } />
                    </div>
                </WebappRender>
                <ContactCenterRender>{legalConfirmation}</ContactCenterRender>
                {signaturePattern}
            </article>
        );
    }

}

BrokerRightsSellStep2.propTypes = {
    startCorporativeOperationSubscriptionFromMifid: PropTypes.func.isRequired,
    handleDisclaimerCheckboxChange: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immBrokerRightsSell: PropTypes.object.isRequired,
    immBrokerSubscription: PropTypes.object.isRequired,
    immCorporatesOperations: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    requestProfile:  PropTypes.func.isRequired,
    resetPrecontractualMail:  PropTypes.func.isRequired,
    sendPreContractualMail:  PropTypes.func.isRequired,
    setDocumentsRead: PropTypes.func.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    getExAnteData: PropTypes.func.isRequired,
}

module.exports.constructor = BrokerRightsSellStep2;
module.exports.BrokerRightsSellStep2 = withRouter(BrokerRightsSellStep2);
